export default __webpack_public_path__ + "static/media/disc-bottom-fork-guards.96389d0a.mp4";